import { useMemo } from 'react';

/**
 * Centralises the five store-derived memos that were duplicated across every
 * dashboard page (DashboardOverview, PriceChangeAlerts, CompetitorCatalog,
 * SaleDiscountTracker, NewProductDetection, BrandCoverage).
 *
 * @param {{ myStoreId: string, myStores: string[], stores: object[] }} args
 * @returns {{ ownedIds, competitorStores, compIds, allStoreIds, myStoreName }}
 */
export function useStores({ myStoreId, myStores = [], stores = [] }) {
  const ownedIds = useMemo(
    () => (myStores.length > 0 ? myStores : myStoreId ? [myStoreId] : []),
    [myStores, myStoreId]
  );

  const competitorStores = useMemo(
    () => stores.filter(s => !ownedIds.includes(s.id)),
    [stores, ownedIds]
  );

  const compIds = useMemo(
    () => competitorStores.map(s => s.id),
    [competitorStores]
  );

  const allStoreIds = useMemo(
    () => stores.map(s => s.id),
    [stores]
  );

  const myStoreName = useMemo(
    () => stores.find(s => s.id === myStoreId)?.name,
    [stores, myStoreId]
  );

  return { ownedIds, competitorStores, compIds, allStoreIds, myStoreName };
}
